module.exports = __webpack_public_path__ + "media/img/responsive-icon-eecf19f1f421e2115b762c5f27649f72.png";